export enum Roles {
  Client = 1,
  Provider = 2,
  Admin = 3,
  Trader = 4,
}
